import React, { useEffect, useState } from 'react'
import Container from '../../../ui/comp/Container'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Axios, baseURL } from '../../../utils/Axios'
import Input from '../../../ui/forms/Input'
import axios from 'axios'
import toast from 'react-hot-toast'
import { displayImage } from '../../../utils/config'
import Button from '../../../ui/comp/Button'

function SpecialOffer() {

    const [formData, setFormData] = useState({
        id: "",
        title: "",
        image: "",
        description: "",
        productId: ""
    })

    const { data } = useQuery({
        queryKey: ["specialOffer"],
        queryFn: async () => {
            const res = await Axios.get('/offer/special')
            return res.data;
        }
    })

    useEffect(() => {
        setFormData(data ||
        {
            id: "",
            title: "",
            image: "",
            description: "",
            productId: ""
        })
    }, [data])


    // File Change
    const fileChange = async (files, i) => {
        if (files?.length) {
            const file = new FormData();

            Object.keys(files).forEach(key => {
                file.append('file', files[key])
            })
            try {
                const res = await axios.post(`${baseURL}/upload`, file)
                const data = await res.data;
                if (data) {
                    setFormData({ ...formData, image: data[0] })
                }
            } catch (error) {
                toast.error(error?.response?.data || "Error while uploading file")
            }
        }
    }

    // Handle Change

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }



    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/offer/special', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Offer updated")
        }
    })

    const sendData = () => {
        mutate(formData)
    }


    return (
        <div className='w-full relative'>
            <Container title={"Special Offer"}>
                <div className="w-full mt-2">
                    <div className="w-full space-y-6">
                        {/* Image */}
                        <div className="flex items-center gap-3">
                            <div className='w-32'><p>Image</p></div>
                            <div className="w-full">
                                <input type="file" id='file' onChange={(e) => fileChange(e.target.files)} />
                                <div className="mt-2">
                                    <img src={displayImage(formData?.image)} alt="" className="w-24 p-1 border" />
                                </div>
                            </div>
                        </div>
                        {/* Title */}
                        <div className="flex items-center gap-3">
                            <div className='w-32'>Title</div>
                            <div className="w-full">
                                <Input id="title" value={formData?.title} onChange={handleInputChange} />
                            </div>
                        </div>

                        {/* Description */}
                        <div className="flex items-center gap-3">
                            <div className="w-32"><p>Description</p></div>
                            <div className="w-full">
                                <Input id="description" value={formData?.description} onChange={handleInputChange} />
                            </div>
                        </div>

                        {/* Product Id */}
                        <div className="flex items-center gap-3">
                            <div className="w-32"><p>Product Id</p></div>
                            <div className="w-full">
                                <Input id="productId" value={formData?.productId} onChange={handleInputChange} />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Button */}
                <div className="mt-6">
                    <Button onClick={sendData} loading={isPending}>Update</Button>
                </div>
            </Container>
        </div>
    )
}

export default SpecialOffer